import {
  Alert,
  Box,
  Breadcrumbs,
  Link as MLink,
  Typography,
} from '@mui/material';
import { GuidanceToursContainer } from '../container/GuidanceToursContainer';
import { useTranslation } from 'react-i18next';
import PageHeader from '../components/PageHeader';
import { Link } from 'react-router-dom';
import { HomeTwoTone } from '@mui/icons-material';

export function GuidancePage() {
  const { t } = useTranslation();
  return (
    <Box>
      <PageHeader title={t('GuidancePage.title')} />
      <Breadcrumbs sx={{ mb: 1 }}>
        <MLink
          component={Link}
          to="/"
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <HomeTwoTone />
        </MLink>
        <MLink component={Link} to="/account">
          {t('nav.account')}
        </MLink>
        <Typography>{t('nav.guidance')}</Typography>
      </Breadcrumbs>
      <Alert severity="info" icon={false} sx={{ mb: 2 }}>
        <Typography variant="body1" sx={{ mb: 2 }}>
          {t('GuidancePage.description')}
        </Typography>
      </Alert>
      <GuidanceToursContainer />
    </Box>
  );
}
